import { Component, OnInit } from '@angular/core';
import { NgbAccordionConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  sections = [
    {
      visible: false,
      header: 'What is the Harappa Learning Insights Dashboard?',
      text: 'The Learning Insights Dashboard is a one-stop destination for our partners to keep track of the learning intervention/s for which they have partnered with Harappa.'
    },
    {
      visible: false,
      header: 'Who is the Learning Insights Dashboard designed for?',
      text: 'The Dashboard is designed keeping the L&D/HR SPOC in mind. No more clunky excels and back and forth on email. We have made it easy to track, share, and take remedial steps. The dashboard enables both, a zoomed-out and zoomed-in view on individual learners.'
    },
    {
      visible: false,
      header: 'What are the main design principles behind the partner dashboard?',
      text: 'Enhanced partner experience by conveying the learning journey in a visual and intuitive manner, and making the learning data actionable.'
    },
    {
      visible: false,
      header: 'What are the key things a partner organization must monitor on the dashboard?',
      text: 'At a high level, there are 3 key parameters to monitor: engagement of the learners with the learning experience, where they stand with the scores they are attaining, and their learning experience on various modules captured via ratings. We provide 3 widgets to keep track of these parameters on the overview page of the dashboard.'
    },
    {
      visible: false,
      header: 'How often is the data updated?',
      text: 'The learning data is updated every 12 hours.'
    },
    // {
    //   visible: false,
    //   header: 'Can my learners access the dashboard?',
    //   text: 'Yes, the learners will be able to access their learning data. It will be available to them within the Harappa IPJ platform.'
    // },
    // {
    //   visible: false,
    //   header: 'How will my learners benefit from having their learning analytics page?',
    //   text: 'We have designed the learner analytics page in a way to nudge the learner towards a better learning behaviour. We define ideal learning behaviour as consistent engagement with the learning experience.'
    // },
    {
      visible: false,
      header: 'I have multiple programs. Will I be able to access all of them in the same place?',
      text: 'Yes, you can simply switch the program you want to see from the top dropdown in case if your organization has partnered for multiple programs.'
    },
    {
      visible: false,
      header: 'How long will the Harappa Learning Insights Dashboard be accessible to me?',
      text: 'The access to the Learning Insights Dashboard doesn’t expire with the program. You continue to have access even after the program.'
    },
    {
      visible: false,
      header: 'How do I log into the Harappa Learning Insights Dashboard on my mobile device?',
      text: 'Go to http://ipj.harappa.education on your mobile device and sign in with your the credentials shared by Harappa with you. Based on the access mapped to your id, you will be automatically directed to the Learning Insights Dashboard.'
    },
    {
      visible: false,
      header: 'Got any questions/feedback to share? Book a short <a href="https://calendly.com/sidzen/chat-w-sid" target="blank">call</a> to discuss.',
      text: ''
    },
  ];
  constructor() {
  }

  ngOnInit(): void {
  }

}
